<div
  class="upload-area"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
  [class.drag-over]="dragOver"
>
  @if (isLoading) {
    <mat-spinner />
  } @else {
    <div class="upload-copy">
      <div class="upload-title">Drop image here</div>
      <div class="upload-subtitle">or choose a file to upload</div>
    </div>
    <button mat-raised-button color="primary" (click)="f_input.click()" [disabled]="isLoading">
      Select image
    </button>
    <input
      type="file"
      (change)="onFileSelected($event)"
      hidden
      #f_input
    />
  }
</div>

